module.exports = __webpack_public_path__ + "static/media/purchase.860e4276.svg";